// Typography

export const HEADING_DATA = [{ code: "<h1>", text: "All HTML Headings" }, { code: "<h6> ", text: " through" }, { text: "are available." }];

export const FONTWEIGHT_DATA = [
  {
    code: "f-w-*",
    text: "Using",
  },
  {
    text: " class, you can change the font weight.",
  },
];

export const LISTING_DATA = [
  { code: "<ul>", text: "All Typography List :-" },
  { code: "<ol>", text: "," },
  { code: "<dl>", text: "&" },
];

export const DISPLAY_DATA = [{ mark: "display heading", text: "Traditional heading elements are designed to work best in the meat of your page content. When you need a heading to stand out, consider using a" }, { text: " a larger, slightly more opinionated heading style." }];

export const INLINE_DATA = [{ text: "Styling for common inline HTML5 elements." }];

export const TEXTCOLOR_DATA = [{ code: "txt-*", text: "You can Give text color by using " }, { text: " class" }];

export const BLOCKQUOTS_DATA = [{ code: "<blockquote>", text: "The " }, { text: " tag specifies a section that is quoted from another source." }];

//Unorder list

export const UNORDER = [{ title: "One who does something not professionally but for pleasure" }, { title: "A person who knows everything" }, { title: "A handwriting that cannot be read" }, { title: "One who looks on the bright side of things" }, { title: "A sound that cannot be heard" }, { title: "The study of ancient writing and scriptures" }, { title: "The study of rocks and soil" }, { title: "creates more sophisticated capabilities for a web page to use coding language." }, { title: "Maintaining contact and communicating clearly are also essential. possess abilities for a designer" }];

//Order list-2

export const ORDER_LIST = [
  {
    dt: "One who looks on the bright side of thing s",
    dd: "-Walt Disney",
  },
  {
    dt: "Life is what happens when you're busy making other plans.",
    dd: "-John Lennon",
  },
  {
    dt: "Whoever is happy will make others happy too. ",
    dd: "-Anne Frank",
  },
  {
    dt: "Life is either a daring adventure or nothing at all.",
    dd: "-Helen Keller",
  },
  {
    dt: "The purpose of our lives is to be happy.",
    dd: "-Dalai Lama",
  },
];

// Text Color

export const TEXT_COLOR = [
  {
    title: "Secondary",
    code: "text-secondary",
  },
  {
    title: "Success",
    code: "text-success",
  },
  {
    title: "Info",
    code: "text-info",
  },
  {
    title: "Warning",
    code: "text-warning",
  },
  {
    title: "Danger",
    code: "text-danger",
  },
  {
    title: "Dark",
    code: "text-dark",
  },
  {
    title: "Success",
    code: "text-success",
  },
];

// BlockQuotes

export const BLOCKQUOTS = [
  {
    text: "In this life we cannot do great things. We can only do small things with great love.",
    name: "Mother Teresa",
    className: "center",
  },
  {
    text: "Live in the sunshine, swim the sea, drink the wild air.",
    name: "Ralph Waldo Emerson",
    className: "end",
  },
];
